import CityPageTemplate from "../city-template/CityPageTemplate";
import { chapelHillConfig } from "./data";

export default function ChapelHillPage() {
  return <CityPageTemplate config={chapelHillConfig} />;
}